// frontend/src/components/admin/ArticleManagement.js
import React, { useState, useEffect } from 'react';
import { 
  Container, 
  Table, 
  Button, 
  Modal, 
  Form, 
  Alert 
} from 'react-bootstrap';
import axios from 'axios';
import baseURL from '../../baseURL';
import AdminNavbar from './AdminNavbar';

const ArticleManagement = () => {
  const [articles, setArticles] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [defaultPercentage, setDefaultPercentage] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  useEffect(() => {
    fetchArticles();
  }, []);

  const fetchArticles = async () => {
    try {
      const response = await axios.get(`${baseURL}/articles/admin`, {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('token')}`
        }
      });

      const raw = response.data;
      setArticles(Array.isArray(raw) ? raw : raw?.data ?? []);
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to fetch articles');
    }
  };

  const handleUpdatePercentage = async (articleId) => {
    try {
      const response = await axios.put(`${baseURL}/articles/update-illegal-percentage/${articleId}`, 
        { percentage: defaultPercentage },
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('token')}`
          }
        }
      );

      setSuccess('Percentage updated successfully');
      fetchArticles();
      setShowModal(false);
    } catch (error) {
      setError(error.response?.data?.message || 'Failed to update percentage');
    }
  };

  return (
    <div>
      <AdminNavbar />
      <Container className="mt-4">
        <h2>Article Management</h2>
        
        {error && <Alert variant="danger">{error}</Alert>}
        {success && <Alert variant="success">{success}</Alert>}

        <Table striped bordered hover>
          <thead>
            <tr>
              <th>Title</th>
              <th>Legal Percentage</th>
              <th>Default Illegal Percentage</th>
              <th>Created By</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {articles.filter(Boolean).map((article) => (
              <tr key={article._id}>
                <td>{article.title}</td>
                <td>{article.percentage}%</td>
                <td>{article.defaultIllegalPercentage || 'Not set'}</td>
                <td>{article.createdBy?.name ?? '—'}</td>
                <td>
                  <Button 
                    variant="primary" 
                    size="sm" 
                    onClick={() => {
                      setSelectedArticle(article);
                      setDefaultPercentage(article.defaultIllegalPercentage || '');
                      setShowModal(true);
                    }}
                  >
                    Set Default
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </Container>

      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Set Default Illegal Percentage</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group controlId="title">
              <Form.Label>Article Title</Form.Label>
              <Form.Control
                type="text"
                value={selectedArticle?.title || ''}
                disabled
              />
            </Form.Group>
            <Form.Group controlId="defaultPercentage">
              <Form.Label>Default Percentage for Illegal Transactions</Form.Label>
              <Form.Control
                type="number"
                value={defaultPercentage}
                onChange={(e) => setDefaultPercentage(e.target.value)}
                min="0"
                max="100"
                placeholder="Enter percentage (0-100)"
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
          <Button 
            variant="primary" 
            onClick={() => handleUpdatePercentage(selectedArticle._id)}
          >
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default ArticleManagement;